import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCreateClientMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseClientEntity } from 'api/helpers/client/parseClientEntity';
import { parseCreateClientParam } from 'api/helpers/client/parseParam';
import { CreateClientParam } from 'api/types/params';

export const useCreateClient = () => {
  const [createClient, { loading, error: apolloError }] =
    useCreateClientMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    createClient: useCallback(
      async (param: CreateClientParam) => {
        const input = parseCreateClientParam(param);
        const res = await createClient({ variables: { input } });

        if (res.data?.client) {
          return parseClientEntity(res.data.client);
        }

        return undefined;
      },
      [createClient]
    ),
  };
};
